import React, { useEffect, useState } from 'react';
import {
	Avatar,
	Box,
	Chip,
	ClickAwayListener,
	FormControlLabel,
	FormLabel,
	List,
	ListItem,
	ListItemText,
	MenuItem,
	MenuList,
	Popper,
	Switch,
	Tab,
	Tabs,
	TextField,
	Tooltip,
	Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AddIconSvg, BottomArrowIcon, DeleteIcon, UserAvtarIcon } from '../../../../../config/svg/CommonSvgIcon';
import { OKRButton } from '../../../../Common/OKRButton';
import { SkillProficiencyDrawer } from './SkillProficiencyDrawer';
import { ErrorIcon } from '../../../../../config/svg/formElementIcons';
import { AvatarGroup } from '@material-ui/lab';

export const CreateSkill: React.FC<any> = (props: any) => {
	const { skillDrawerData, setSkillDrawerData, formPostData, setFormPostData, formValidateData, setFormValidateData } =
		props;
	const { t } = useTranslation();
	const [tabSelected, setTabSelected] = useState<Number>(0);
	const [openLevels, setOpenLevels] = useState<Boolean>(false);
	const [openRoles, setOpenRoles] = useState<any>({ open: false, data: {} });
	const [selectedLevel, setSelectedLevel] = useState<any>({});
	const [proficiencyDescriptions, setProficiencyDescriptions] = useState(
		skillDrawerData?.skillFrsmworkProficiencyResponses?.map((item: any) => item.proficiencyScaleDescription) || []
	);
	const [hoveredRoleIdx, setHoveredRoleIdx] = useState<number | null>(null);
	const [anchorEl, setAnchorEl] = useState<any>(null);

	const handleOpenRolesPopup = (event: any, idx: number) => {
		setAnchorEl(event.currentTarget);
		setHoveredRoleIdx(idx);
	};
	const handleCloseRolesPopup = () => {
		setHoveredRoleIdx(null);
		setAnchorEl(null);
	};

	useEffect(() => {
		setProficiencyDescriptions(
			skillDrawerData?.skillFrsmworkProficiencyResponses?.map((item: any) => item.proficiencyScaleDescription) || []
		);
	}, [skillDrawerData?.skillFrsmworkProficiencyResponses]);

	const handleProficiencyFieldChange = (name: string, value: any) => {
		setFormPostData({ ...formPostData, [name]: value });
		setFormValidateData({ ...formValidateData, [name]: '' });
	};
	const handleTabChange = (event: any, newValue: Number) => {
		setTabSelected(newValue);
	};
	function a11yProps(index: number) {
		return {
			id: `skill-tab-${index}`,
			'aria-controls': `skill-tabpanel-${index}`,
		};
	}
	const handleClickLevel = () => {
		setOpenLevels((prev: Boolean) => !prev);
	};

	const handleLevelSelect = (level: any) => {
		setSelectedLevel(level);
		setOpenLevels(false);
		setFormPostData({ ...formPostData, parentLevelId: level.levelAttributeDataId });
		setFormValidateData({ ...formValidateData, parentLevelId: '' });
	};
	const handleClickAway = () => {
		setOpenLevels(false);
		setOpenRoles(false);
	};
	const handleMapRoles = (item: any) => {
		setOpenRoles({ open: true, data: item });
	};

	const setProficientyData = (event: any, type: string, checkedUsers: any[]) => {
		if (type === 'save') {
			const updatedSkillData = { ...formPostData };
			updatedSkillData.proficiencyMapping = updatedSkillData.proficiencyMapping.map((item: any, idx: number) => {
				if (item.proficiencyScaleId === openRoles.data.proficiencyScaleId) {
					return {
						...item,
						performanceRoleResponsesUsers: checkedUsers,
					};
				}
				return item;
			});
			setFormPostData({ ...updatedSkillData });
		}
		setOpenRoles({ open: false, data: {} });
	};

	return (
		<>
			<Tabs
				className='okr-tabs drawer-tabs'
				value={tabSelected}
				onChange={handleTabChange}
				aria-label='Admin Skill Tabs'
			>
				<Tab label={t('Skill Details')} value={0} {...a11yProps(0)} />
				<Tab label={t('Add Bulk Skills')} value={1} {...a11yProps(1)} />
			</Tabs>
			<Box className='drawer-tabs-panel skill-framework-panel'>
				<form className='drawer-form-fields' noValidate autoComplete='off'>
					<Box className='skill-framework-form'>
						{tabSelected === 0 && (
							<Box className='skill-framework-form-fields'>
								{/* Skill Framework Name */}
								<Box className='drawer-input-field'>
									<Box className='skill-framework-name-field'>
										<TextField
											fullWidth
											id='skillName'
											className='field-col2 helperText-bottom'
											label={t('Skill Name')}
											value={formPostData?.name || ''}
											onChange={(e) => handleProficiencyFieldChange('name', e.target.value)}
											placeholder={t('Enter skill name')}
											name='skillName'
											InputLabelProps={{ shrink: true }}
											InputProps={{ 'aria-label': t('skillName'), disableUnderline: true }}
											error={formValidateData.name || ''}
											helperText={
												formValidateData.name && (
													<React.Fragment>
														<ErrorIcon />
														{formValidateData.name}
													</React.Fragment>
												)
											}
										/>
										<Box className='skill-status field-col2'>
											<FormControlLabel
												control={
													<Switch
														name='isAllEmployees'
														checked={formPostData?.status || ''}
														onChange={(e) => handleProficiencyFieldChange('status', e?.target?.checked ? 1 : 0)}
													/>
												}
												label={t('Active Skill')}
												labelPlacement='end'
												className='toggle-label'
											/>
										</Box>
									</Box>
								</Box>
								{/* Skill Framework Description */}
								<Box className='drawer-input-field'>
									<Box className='skill-framework-desc-field'>
										<TextField
											fullWidth
											id='skillDescription'
											className='helperText-bottom'
											label={t('Skill Description')}
											name='skillDescription'
											value={formPostData?.description || ''}
											onChange={(e) => handleProficiencyFieldChange('description', e.target.value)}
											placeholder={t('Type skill description here')}
											multiline
											minRows={2}
											InputLabelProps={{ shrink: true }}
											InputProps={{ 'aria-label': t('skillDescription'), disableUnderline: true }}
										/>
									</Box>
								</Box>
								{/* Map Skill Framework Description */}
								<Box className='drawer-input-field'>
									<Box className='map-skill-last-level-field'>
										<FormLabel>
											{t('Map skill to ')}
											{skillDrawerData?.levelName ? skillDrawerData?.levelName : t('last level')}
										</FormLabel>{' '}
										<Box className={`okr-team-dropdown scale-type-dropdown ${openLevels ? 'active' : ''}`}>
											<OKRButton
												className={'dropdown-button'}
												icon={<BottomArrowIcon />}
												handleClick={handleClickLevel}
												text={selectedLevel?.levelName ? selectedLevel?.levelName : t('Select level')}
											/>
											{openLevels && (
												<ClickAwayListener onClickAway={() => setOpenLevels(false)}>
													<Box className='team-dropdown'>
														<Box className='team-dropdown-inner'>
															<Box className='dropdown-multi-list-sub-panel'>
																<List component='div' disablePadding>
																	{skillDrawerData?.skillFrameworkLastLevelAttributeResponses?.map((level: any) => (
																		<ListItem
																			button
																			key={level.levelAttributeDataId}
																			selected={selectedLevel?.levelAttributeDataId === level.levelAttributeDataId}
																			onClick={() => handleLevelSelect(level)}
																		>
																			<ListItemText>{level.levelName}</ListItemText>
																		</ListItem>
																	))}
																</List>
															</Box>
														</Box>
													</Box>
												</ClickAwayListener>
											)}
										</Box>
									</Box>
								</Box>
								<Box className='drawer-input-field'>
									<Box className='skill-in-demand-field'>
										<FormControlLabel
											control={
												<Switch
													name='isAllEmployees'
													checked={formPostData?.isInDemand || ''}
													onChange={(e) => handleProficiencyFieldChange('isInDemand', e?.target?.checked || false)}
												/>
											}
											label={t('In demand')}
											labelPlacement='end'
											className='toggle-label'
										/>
										<Typography variant='h6'>
											Select if the skill is a current priority. Helps filter key skills for workforce planning,
											training focus, or role mapping.
										</Typography>
									</Box>
								</Box>
								<Box className='drawer-blue-bg-full map-proficiency-area'>
									<Box className='map-proficiency-header'>
										<Typography>{t('Map role and courses with each proficiency')}</Typography>
										<Typography variant='h6'>
											{t('Select roles and courses for each proficiency to enhance skill development.')}
										</Typography>
									</Box>
									<Box className='okr-list-panel-head'>
										<List disablePadding component='ul'>
											<ListItem className='map-proficiency-col1'>
												<Typography variant='body2' className='sort-title'>
													<span className='sortable-label'>
														<span className='txt-wrap'>{t('Proficiency')}</span>
													</span>
												</Typography>
											</ListItem>
											<ListItem className='map-proficiency-col2'>
												<Typography variant='body2' className='sort-title'>
													<span className='sortable-label'>
														<span className='txt-wrap'>{t('Roles')}</span>
													</span>
												</Typography>
											</ListItem>
											{/* <ListItem className='map-proficiency-col3'>
												<Typography variant='body2' className='sort-title'>
													<span className='sortable-label'>
														<span className='txt-wrap'>{t('Courses')}</span>
													</span>
												</Typography>
											</ListItem> */}
										</List>
									</Box>
									{formPostData?.proficiencyMapping?.map((item: any, idx: number) => (
										<Box className='map-proficiency-content' key={item.proficiencyScaleId || idx}>
											<List disablePadding component='ul'>
												<ListItem className='map-proficiency-col1'>
													<TextField
														fullWidth
														id='proficiencyName'
														className='field-col1 helperText-bottom'
														label={item.proficiencyScaleName}
														placeholder={t('Proficiency scale description')}
														name='proficiencyName'
														onChange={(e) => {
															const updatedMapping = [...formPostData.proficiencyMapping];
															updatedMapping[idx].proficiencyDescription = e.target.value;
															setFormPostData({ ...formPostData, proficiencyMapping: updatedMapping });
														}}
														value={item.proficiencyScaleDescription || ''}
														InputLabelProps={{ shrink: true }}
														InputProps={{ 'aria-label': t('proficiencyName'), disableUnderline: true }}
													/>
												</ListItem>
												<ListItem className='map-proficiency-col2'>
													<Box className='role-content'>
														<Box
															className='user-role-info'
															aria-haspopup='true'
															aria-owns={hoveredRoleIdx === idx ? 'mouse-over-popover' : undefined}
															onMouseOver={(e) => handleOpenRolesPopup(e, idx)}
															onMouseLeave={handleCloseRolesPopup}
														>
															<Box className='user-avatar-count'>
																<AvatarGroup className='avatar-count-group' max={1}>
																	<Avatar className='avatar-default-grey' alt='User Avtar'>
																		<UserAvtarIcon />
																	</Avatar>
																	{item.performanceRoleResponsesUsers &&
																	item.performanceRoleResponsesUsers.length > 0 ? (
																		<Avatar alt='Role Count'>{item.performanceRoleResponsesUsers?.length}</Avatar>
																	) : (
																		<></>
																	)}
																</AvatarGroup>
															</Box>
														</Box>
														<OKRButton
															className='add-btn2'
															id={`add-custom-scale-btn-${idx}`}
															icon={<AddIconSvg />}
															color='primary'
															handleClick={() => handleMapRoles(item)}
														/>

														<Popper
															className={'assigned-user-popover'}
															open={hoveredRoleIdx === idx}
															anchorEl={anchorEl}
															transition
															placement={'bottom-start'}
															id='popoverList'
														>
															<ClickAwayListener onClickAway={handleCloseRolesPopup}>
																<Box className='assignedUser-details-inner'>
																	{item?.performanceRoleResponsesUsers &&
																	item?.performanceRoleResponsesUsers?.length > 0 ? (
																		<MenuList className='assignedUser-details-list'>
																			{item.performanceRoleResponsesUsers.map((role: any, roleIdx: number) => (
																				<MenuItem key={roleIdx} id={`assigned-role-${roleIdx}`}>
																					<Box className={`assignedUser-details-left user-name-only`}>
																						<Box className='assignedUser-info'>
																							{role?.performanceRoleName && role?.performanceRoleName?.length > 0 ? (
																								<Tooltip title={role?.performanceRoleName} arrow>
																									<Typography variant='h4' className='tooltip-text'>
																										{role?.performanceRoleName}
																									</Typography>
																								</Tooltip>
																							) : (
																								<Typography variant='h4'>{role?.performanceRoleName}</Typography>
																							)}
																						</Box>
																					</Box>
																				</MenuItem>
																			))}
																		</MenuList>
																	) : (
																		<Box className='user-no-record'>
																			<Typography variant='body2'>{t('noRoles')}</Typography>
																		</Box>
																	)}
																</Box>
															</ClickAwayListener>
														</Popper>
														<Typography variant='subtitle1'>
															<em>{t('mapRoles')}</em>
														</Typography>
													</Box>
												</ListItem>
												{/* <ListItem className='map-proficiency-col3'>
													<OKRButton
														className='add-btn2'
														id={`add-custom-scale-btn-${idx}`}
														icon={<AddIconSvg />}
														color='primary'
														handleClick={() => handleMapRoles(item)} // implement if needed
													/>
													<Typography variant='subtitle1'>
														<em>{t('mapCourses')}</em>
													</Typography>
												</ListItem> */}
											</List>
										</Box>
									))}
								</Box>
							</Box>
						)}
						{tabSelected === 1 && (
							<Box className='skill-framework-form-fields'>
								<Box className='drawer-input-field'>
									<Typography>To be develop</Typography>
								</Box>
							</Box>
						)}
					</Box>
				</form>
			</Box>
			{openRoles.open && (
				<SkillProficiencyDrawer
					rolesData={skillDrawerData?.performanceRoleResponses}
					handleSaveClick={(event: any, type: string, checkedUsers: any[]) => {
						setProficientyData(event, type, checkedUsers);
					}}
					setOpenRoles={setOpenRoles}
					openRoles={openRoles}
					allProficiency={formPostData?.proficiencyMapping}
				/>
			)}
		</>
	);
};
